module.exports = __webpack_public_path__ + "static/media/product (10).7b19cd05.jpg";